<template>
  <div class="systemuserlist-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('sm2')">
        <el-col :span="8" v-if="userinfo.tenantType === 0 || userinfo.tenantType === 1">
          <el-form-item :label="$t('manage.name86')" prop="tenantIds" clearable>
            <el-cascader v-model="queryInfo.tenantIds" :placeholder="$t('public.name1')" :style="$i18n.locale === 'en' ? 'width:360px' : ''" @change="handleChange" :props="{ lazy: true, lazyLoad: loadOptions }" clearable></el-cascader>
          </el-form-item>
        </el-col>

        <el-col :span="8" v-else>
          <el-form-item prop="tenantId" :label="$t('manage.name86')">
          <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')" :style="$i18n.locale === 'en' ? 'width:360px' : 'width:100%'">
            <el-option v-for="item in manufacturerNameOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
          </el-select>
        </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="$t('manage.name1')" prop="keyword">
            <el-input v-model="queryInfo.keyword" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('manage.name2')" prop="status">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')" style="width:130px;">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div>
        <el-button type="primary" size="medium" v-if="buttonPerms.indexOf('user/list') > -1" @click="getPageList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
      </div>
    </div>
    <div class="add-user">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="addUser(null)" v-if="buttonPerms.indexOf('user/save') > -1">{{ $t('manage.name3') }}</el-button>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="loading">
      <el-table-column :label="$t('manage.name79')" prop="tenantName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name4')" prop="loginName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name5')" prop="userName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name6')" prop="roleName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name7')" prop="phone" sortable></el-table-column>
      <el-table-column :label="$t('manage.name8')" prop="email" sortable></el-table-column>
      <el-table-column :label="$t('manage.name9')" prop="updateTime" sortable width="140">
        <template slot-scope="scope">
          {{ scope.row.updateTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name10')" prop="loginDate" sortable width="180px">
        <template slot-scope="scope">
          {{ scope.row.loginDate | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name11')" prop="loginIp" sortable width="160"></el-table-column>
      <el-table-column :label="$t('manage.name12')" prop="status" sortable>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-color="#0f73e6" inactive-color="#dcdfe6"> </el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name15')" width="188px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="addUser(scope.row)" v-if="buttonPerms.indexOf('user/update') > -1">{{ $t('manage.name17') }}</el-button>
          <el-button type="text" @click="delUser(scope.row)" v-if="buttonPerms.indexOf('user/delete') > -1" style="color:#ea4646">{{ $t('manage.name18') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <AppDialog
      width="400px"
      :title="merchantUserInfo.userId === '' ? $t('manage.name89') : $t('manage.name101')"
      v-if="merchantUserInfoDialog"
      :visible.sync="merchantUserInfoDialog"
      :before-close="close"
    >
      <el-form ref="userFormRef" :model="merchantUserInfo" :rules="merchantUserInfo.userId === '' ? merchantUserInfoRules : merchantUserInfoRules1" :label-width="formLabelWidth('md')">
        <el-form-item prop="tenantId" :label="$t('manage.name86')">
          <el-select v-model="merchantUserInfo.tenantId" :placeholder="$t('public.name1')" style="width:100%" @change="changeTenant">
            <el-option v-for="item in manufacturerNameOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="loginName" :label="$t('manage.name20')">
          <el-input v-model="merchantUserInfo.loginName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="loginPwd" :label="$t('manage.name21')">
          <el-input v-model="merchantUserInfo.loginPwd" :placeholder="$t('public.name5')" show-password></el-input>
        </el-form-item>

        <el-form-item prop="userName" :label="$t('manage.name22')">
          <el-input v-model="merchantUserInfo.userName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>

        <el-form-item prop="nickName" :label="$t('manage.name23')">
          <el-input v-model="merchantUserInfo.nickName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="phone" :label="$t('manage.name24')">
          <el-input v-model="merchantUserInfo.phone" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>

        <!-- <el-form-item prop="email" :label="$t('manage.name26')">
          <el-input v-model="merchantUserInfo.email" :placeholder="$t('public.name5')"></el-input>
        </el-form-item> -->

        <el-form-item :label="$t('manage.name25')" prop="roles">
          <el-select v-model="merchantUserInfo.roles" :placeholder="$t('public.name1')" style="width:100%;">
            <el-option v-for="item in rolesOptions" :key="item.roleId + ''" :label="item.roleName" :value="item.roleId + ''"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="status" :label="$t('manage.name2')">
          <el-switch v-model="merchantUserInfo.status" active-color="#0f73e6" inactive-color="#dcdfe6"> </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
  </div>
</template>
<script>
import { userList, tenantList, userSave, userUpdate, userDelete, sysroleList } from '@/api/manage.js'
import { validateEmail, validatePass } from '@/utils/utils.js'
import { mapGetters } from 'vuex'
import AppDialog from '@/components/AppDialog/index.vue'
export default {
  components: { AppDialog },
  computed: {
    ...mapGetters(['userinfo']),
    statusOptions() {
      return [
        { value: 2, label: this.$t('operate.name98') },
        { value: 0, label: this.$t('operate.name48') },
        { value: 1, label: this.$t('operate.name39') }
      ]
    }
  },
  data() {
    return {
      queryInfo: {
        tenantId: '',
        tenantIds: [],
        keyword: '',
        status: 2,
        page: 1,
        limit: 10
      },
      loading: false,
      tableList: [],
      cascaderOptions: [],
      manufacturerNameOptions: [],
      total: 0,
      selectList: [],
      merchantUserInfoRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('bike.name481'),
            trigger: 'blur'
          }
        ],
        loginName: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        loginPwd: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        roles: [
          {
            required: true,
            message: this.$t('screen.name25'),
            trigger: 'blur'
          }
        ]
      },
      merchantUserInfoRules1: {
        tenantId: [
          {
            required: true,
            message: this.$t('bike.name481'),
            trigger: 'blur'
          }
        ],
        loginName: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        roles: [
          {
            required: true,
            message: this.$t('screen.name25'),
            trigger: 'blur'
          }
        ]
      },
      merchantUserInfo: {
        userId: '',
        loginName: '',
        loginPwd: '',
        userName: '',
        nickName: '',
        tenantId: '',
        tenantType: 2,
        phone: '',
        email: '',
        roles: '',
        status: true
      },
      merchantUserInfoDialog: false,
      rolesOptions: [],
      buttonPerms: ''
    }
  },
  created() {
    this.queryInfo.tenantIds.push(parseInt(this.$route.query.parentId))
    this.queryInfo.tenantIds.push(parseInt(this.$route.query.tenantId))
    this.queryInfo.tenantId = this.$route.query.tenantId
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  mounted() {
    this.getTenantList()
    this.queryList()
  },
  methods: {
    resetQuery() {
      this.queryInfo = {
        tenantId: '',
        tenantIds: [],
        keyword: '',
        status: 2,
        page: 1,
        limit: 10
      }
      this.queryList()
    },
    getPageList() {
      this.queryInfo.page = 1
      this.queryInfo.limit = 10
      this.queryList()
    },
    queryList() {
      this.loading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit,
        tenantType: 2
      }
      if (this.queryInfo.keyword) {
        data.keyword = this.queryInfo.keyword.trim()
      }
      if (this.queryInfo.status !== 2) {
        data.status = this.queryInfo.status === 0
      }
      if (this.queryInfo.tenantId) {
        data.tenantId = this.queryInfo.tenantId
      }
      userList(data)
        .then(res => {
          this.tableList = res.data.list
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.tableList = []
          this.total = 0
          this.loading = false
        })
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2
      }
      tenantList(data)
        .then(res => {
          this.manufacturerNameOptions = res.data.list
          this.queryInfo.tenantId = this.manufacturerNameOptions[0].tenantId
        })
        .catch(() => {
          this.manufacturerNameOptions = []
        })
    },
    changeTenant(e) {
      this.getSysroleList(e)
    },
    getSysroleList(tenantId) {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2,
        tenantId: tenantId
      }
      sysroleList(data)
        .then(res => {
          this.rolesOptions = res.data.list
        })
        .catch(() => {})
    },

    addUser(row) {
      this.merchantUserInfoDialog = true
      if (row !== null) {
        this.merchantUserInfo = {
          userId: row.userId,
          loginName: row.loginName,
          loginPwd: '',
          userName: row.userName,
          nickName: row.nickName,
          tenantId: row.tenantId,
          phone: row.phone,
          email: row.email,
          roles: row.roleId,
          tenantType: 2,
          status: row.status
        }
        this.getSysroleList(row.tenantId)
      } else {
        if (this.queryInfo.tenantId) {
          this.merchantUserInfo.tenantId = Number(this.queryInfo.tenantId)
        }
        this.getSysroleList(this.queryInfo.tenantId)
      }
    },
    close() {
      this.merchantUserInfoDialog = false
      this.merchantUserInfo = {
        userId: '',
        loginName: '',
        loginPwd: '',
        userName: '',
        nickName: '',
        tenantId: '',
        phone: '',
        email: '',
        roles: '',
        tenantType: 2,
        status: true
      }
    },

    delUser(row) {
      this.$confirm(this.$t('manage.name126'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          userDelete({
            id: row.userId + ''
          })
            .then(res => {
              if (res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$t('public.name30')
                })
                this.queryInfo.page = 1
                this.queryList()
              }
            })
            .catch(() => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },

    submitForm() {
      this.$refs.userFormRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        if (this.merchantUserInfo.userId) {
          userUpdate(this.merchantUserInfo)
            .then(res => {
              if (res.code === 200) {
                this.loading = false
                this.close()
                this.queryInfo.page = 1
                this.queryList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          userSave(this.merchantUserInfo)
            .then(res => {
              if (res.code === 200) {
                this.loading = false
                this.queryInfo.page = 1
                this.close()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },

    loadOptions(node, resolve) {
      if (node.level === 2) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }

      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 1
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    handleChange(value) {
      // 处理选项变化
      this.queryInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
      console.log('========2', this.queryInfo.tenantIds)
      this.queryList()
    },

    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.queryList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.queryList()
    }
  }
}
</script>
<style lang="scss" scoped>
.systemuserlist-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;

    // Keep controls flush after labels; space between search items (Permissions-like)
    ::v-deep .el-form-item__label {
      width: auto !important;
      padding-right: 8px;
      justify-content: flex-start !important;
      text-align: left !important;
    }

    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }

    ::v-deep .el-col {
      padding-right: 32px;
      box-sizing: border-box;
    }

    ::v-deep .el-col:last-child {
      padding-right: 0;
    }
  }

  .qiyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}
</style>
